import React from "react";
import { FormattedAmount } from "../FormattedAmount.js";

type Props = {
  itemsCount: number;
  label: string;
  total: number;
};

/**
 * Renders VAT report field subheading.
 */
export const FieldSubHeading = ({ itemsCount, label, total }: Props) => {
  return (
    <tr>
      <td colSpan={1} rowSpan={1 + itemsCount} className="vertical-top">
        {label}
      </td>
      <td colSpan={10} className="text-right">
        <FormattedAmount cents={total} />
      </td>
    </tr>
  );
};
